import { Box, Typography } from "@mui/material"

const Loader = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "309.75px",
                width: "100%",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    gap: "4px",
                    mb: 2,
                }}
            >
                {[...Array(3)].map((_, index) => (
                    <Box
                        key={index}
                        sx={{
                            width: "4px",
                            height: "20px",
                            background: "linear-gradient(0deg, #F6C100 0%, #F10000 49%, #CC0000 100%)",
                            animation: "loadingAnimation 1s ease-in-out infinite",
                            animationDelay: `${index * 0.2}s`,
                            "@keyframes loadingAnimation": {
                                "0%, 100%": {
                                    transform: "scaleY(1)",
                                },
                                "50%": {
                                    transform: "scaleY(2)",
                                },
                            },
                        }}
                    />
                ))}
            </Box>
            <Typography
                sx={{
                    fontSize: "14px",
                    color: "#000000",
                }}
            >
                Loading...
            </Typography>
        </Box>
    )
}

export default Loader

